export var getStepNavigation = function (search, baseSegment) {
    if (baseSegment === void 0) { baseSegment = "/ventas"; }
    var raw = localStorage.getItem("steps");
    if (!raw)
        return undefined;
    var steps = JSON.parse(raw);
    var idx = steps.findIndex(function (s) { return s.id === search || s.pathUrl === search; });
    if (idx === -1)
        return undefined;
    var pick = function (step) {
        return (step === null || step === void 0 ? void 0 : step.pathUrl) && step.pathUrl !== "" ? step.pathUrl : step.id;
    };
    var isUrlPath = function (val) { return val.startsWith("/"); };
    var formatTarget = function (val) {
        if (!val)
            return undefined;
        return isUrlPath(val) ? val : "".concat(baseSegment, "/").concat(val);
    };
    var currentRaw = pick(steps[idx]);
    var nextRaw = steps[idx + 1] ? pick(steps[idx + 1]) : undefined;
    var backRaw = steps[idx - 1] ? pick(steps[idx - 1]) : undefined;
    var nextFormatted = nextRaw // SI YA NO HAY STEP MANDA AL HOME
        ? formatTarget(nextRaw)
        : idx === steps.length - 1
            ? "/insurancePoliciesSummary"
            : undefined;
    return {
        current: currentRaw,
        next: nextFormatted,
        back: formatTarget(backRaw),
    };
};
